import { CheckCircleOutlineIcon } from './CheckCircleOutlineIcon';

/**
 * author: Google
 * id F609EE7E-AAB4-4CE7-A002-D0F7ECF89609
 * name check-circle-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/check-circle-outline.svg
 * tags
 * - Form 
 */
export const TickCircleOutlineIcon = CheckCircleOutlineIcon;
export default TickCircleOutlineIcon